import React from 'react';
import './Text.module.scss';
import ReactMarkdown from 'react-markdown';

type Props = {
  item: any;
};

export default function Text({ item }: Props) {
  // console.log(item, 'item');
  return <ReactMarkdown children={item.attributes.text} />;
}
